import { render } from "./AppPanelMenu.vue?vue&type=template&id=89782e3e"
import script from "./AppPanelMenu.vue?vue&type=script&lang=js"
export * from "./AppPanelMenu.vue?vue&type=script&lang=js"

import "./AppPanelMenu.vue?vue&type=style&index=0&id=89782e3e&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__